import type { CurrencyFormatterOptions } from 'hooks/useNumberFormatters'
import { useCurrencyFormatter } from 'hooks/useNumberFormatters'
import type { CurrencyFormat } from 'lib/format/formatCurrencyIntl'
import { memo } from 'react'
import styled from 'styled-components'

interface Props extends CurrencyFormatterOptions {
  value: number
  format?: CurrencyFormat

}

/**
 * Keep logical order (e.g. `450 A$`) inside RTL layouts.
 * Prefer this over Unicode LRI/PDI in formatter strings.
 */
const CurrencyText = styled.span`
  direction: ltr;
  unicode-bidi: isolate;
`

function FormatCurrency({ value, format, ...rest }: Props) {
  const formatter = useCurrencyFormatter(rest)
  const formatted = formatter(value, format)

  return <CurrencyText>{formatted}</CurrencyText>
}

export default memo(FormatCurrency)
